"use strict";
/** Helpers de apresentação e normalização da nota de habilidade (1.0–5.0). */
Object.defineProperty(exports, "__esModule", { value: true });
exports.clampSkill = clampSkill;
exports.isValidRatingStep = isValidRatingStep;
exports.toStars = toStars;
exports.formatSkill = formatSkill;
const config_1 = require("@nossorachao/config");
/** Prende o valor à faixa válida e arredonda na precisão de armazenamento. */
function clampSkill(value) {
    const clamped = Math.min(Math.max(value, config_1.SKILL.MIN), config_1.SKILL.MAX);
    const factor = 10 ** config_1.SKILL.PRECISION;
    return Math.round(clamped * factor) / factor;
}
/** Valida se a nota enviada por um avaliador respeita o passo de meia estrela. */
function isValidRatingStep(value) {
    if (value < config_1.SKILL.MIN || value > config_1.SKILL.MAX)
        return false;
    const steps = (value - config_1.SKILL.MIN) / config_1.SKILL.STEP;
    return Math.abs(steps - Math.round(steps)) < 1e-9;
}
/** Estrelas cheias/meia/vazias para renderização: 3.7 → 4 cheias arredondando meia. */
function toStars(value) {
    const rounded = Math.round(value * 2) / 2;
    const full = Math.floor(rounded);
    const half = rounded - full >= 0.5;
    return { full, half, empty: 5 - full - (half ? 1 : 0) };
}
/** Formata a nota sempre com uma casa decimal, no padrão pt-BR: 3.7 → "3,7". */
function formatSkill(value) {
    return value.toFixed(1).replace('.', ',');
}
//# sourceMappingURL=skill.js.map